/*
  Transición suave de la barra de progreso de descuentos.

  El tema reemplaza el DOM de .cart__items vía AJAX cuando el carrito cambia,
  así que la transición CSS no tiene "estado anterior" del que partir.
  Este script recuerda el último % de fill y, cuando aparece una nueva
  .cart-tier-bar en el DOM, la fija primero al % anterior y luego anima
  hasta el nuevo destino.
*/
(function () {
  var previousFillPercent = null;
  var TRANSITION_MS = 800;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function applySmoothTransition(bar) {
    bar = bar || document.querySelector('.cart-tier-bar');
    if (!bar) {
      previousFillPercent = 0;
      return;
    }
    var fill = bar.querySelector('.cart-tier-bar__fill');
    if (!fill) return;

    var targetWidth = fill.style.width;
    if (!targetWidth) return;
    var targetPercent = parseFloat(targetWidth);
    if (isNaN(targetPercent)) return;

    if (previousFillPercent !== null && previousFillPercent !== targetPercent) {
      // Empezar desde el % anterior (sin transición)
      fill.style.transition = 'none';
      fill.style.width = previousFillPercent + '%';
      // Forzar reflow para que el navegador registre el width 0-state
      void fill.offsetWidth;
      // Activar transición y mover al destino
      fill.style.transition = 'width ' + TRANSITION_MS + 'ms ' + EASING;
      fill.style.width = targetPercent + '%';
    }

    previousFillPercent = targetPercent;
  }

  function init() {
    applySmoothTransition();

    // Detectar cuando una nueva barra aparece en el DOM (AJAX del carrito)
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          var bar = null;
          if (node.matches && node.matches('.cart-tier-bar')) {
            bar = node;
          } else if (node.querySelector) {
            bar = node.querySelector('.cart-tier-bar');
          }
          if (bar) {
            applySmoothTransition(bar);
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
